import { render, staticRenderFns } from "./SliderImages.vue?vue&type=template&id=b3c185f4&scoped=true"
import script from "./SliderImages.vue?vue&type=script&lang=js"
export * from "./SliderImages.vue?vue&type=script&lang=js"
import style0 from "./SliderImages.vue?vue&type=style&index=0&id=b3c185f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c185f4",
  null
  
)

export default component.exports